import React from 'react';
import { Box, Button, Theme, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { COLOR_WHITE } from '@monorepo/shared/src/themes/studentAppTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import letterBooksBackground from 'assets/images/letter-book-background.png';
import letterBooks from 'assets/images/letter-books.png';
import letterBookZack from 'assets/images/letter-book-zack.png';

const t = (key: string) => translate('a11y', key);
const tHome = (key: string) => translate('home', key);

type Props = {
  onClick: any;
  styles: { [key: string]: any };
  components: any;
};

const LetterBooksIcon: React.FC<Props> = ({ onClick, styles = {}, components }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.between('xs', 'md'));
  const classes = useStyles();

  return (
    <Box
      className={`${classes.zackAndLetterBooks} ${isMobile ? classes.scale : ''}`}
      style={styles}
    >
      <img alt={t('alt.zackAndTheZipper')} src={letterBookZack} />
      <Button
        className={`${classes.button} ${classes.letterBooksBtn}`}
        disableTouchRipple
        onClick={onClick}
      >
        <div className={classes.letterBooksBackgroundImg}>
          <img alt={t('alt.letterBooks')} className={classes.letterBook} src={letterBooks} />
          <Typography variant="h1" className={classes.letterBooksText}>
            {tHome('letterBooks')}
          </Typography>
        </div>
      </Button>
      {components && <div>{components}</div>}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  button: {
    '&:hover': {
      background: 'none',
    },
  },
  letterBook: {
    left: remCalc(25),
    position: 'absolute',
    top: remCalc(30),
  },
  letterBooksBtn: {
    left: remCalc(200),
    position: 'absolute',
    top: remCalc(0),
  },
  letterBooksBackgroundImg: {
    backgroundImage: `url(${letterBooksBackground})`,
    height: remCalc(296),
    width: remCalc(290),
  },
  letterBooksText: {
    color: COLOR_WHITE,
    left: remCalc(90),
    lineHeight: remCalc(40),
    position: 'absolute',
    top: remCalc(160),
    width: remCalc(10),
  },
  letterBookZack: {
    position: 'relative',
    zIndex: 1,
  },
  zackAndLetterBooks: {
    left: '15vw',
    position: 'absolute',
    top: '15vh',
  },
  scale: {
    left: `-${remCalc(35)} !important`,
    top: '17vh !important',
    transform: 'scale(0.85)',
  },
}));

export default LetterBooksIcon;
